export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "fetch.worker.aa3c0892c5e59abe.es5.worker.js");
}
